


































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import Button from "@/shared/components/ui/Button.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsaStore } from "@/shared/store/hsa";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Button
  }
})
export default class ExpenseEligibilityWidget extends Vue {
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  featureFlagStore = useFeatureFlagStore();
  hsaStore = useHsaStore();
  custodianSettingsStore = useCustodianSettingsStore();

  formatCurrency = formatCurrency;

  mounted () {
    this.hsaStore.loadTransactionTotals();
  }

  get useNewExpenses (): boolean {
    return this.custodianSettingsStore.displayNewHealthcareExpenses;
  }
}
